import type { ReactElement, SyntheticEvent } from "react"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import { isResponsePending } from "@onestore/onestore-store-common/http"
import type { DomainBundleHook } from "@gatsby-plugin-domain-search/hooks/useMainDomainBundleQuery"
import SingleLineDomainSearchBar from "~/components/SingleLineDomainSearchBar"
import SubmitFieldBottomTexts from "./SubmitFieldBottomTexts"

type SubmitFieldProps = {
  disabled: boolean
  requestStatus: number
  pool?: number
  onNextStepClick?: { (): void }
  nextStep?: boolean | null
  hideText?: boolean
  phrase: string
  setPhrase: { (string): void }
  bundleDomainsExtensions?: DomainBundleHook[]
  inputWrapperId?: string
  onSearchClicked: {
    (
      phrase: string,
      pool: number | undefined,
      bundleDomainsExtensions?: DomainBundleHook[]
    ): void
  }
}

export default function SubmitField({
  disabled,
  requestStatus,
  pool,
  nextStep,
  hideText,
  onNextStepClick,
  phrase,
  setPhrase,
  bundleDomainsExtensions,
  inputWrapperId,
  onSearchClicked,
}: SubmitFieldProps): ReactElement<SubmitFieldProps> | null {
  if (disabled) {
    return null
  }

  const handleOnChange = (event: SyntheticEvent<HTMLInputElement> | string) => {
    const value = typeof event === "string" ? event : event.currentTarget.value

    setPhrase(value)
  }

  return (
    <>
      <PushOrg bottomSpace={hideText ? 0 : 3}>
        <SingleLineDomainSearchBar
          inputWrapperId={inputWrapperId}
          value={phrase}
          loading={isResponsePending(requestStatus)}
          onChange={handleOnChange}
          onSearch={() => {
            onSearchClicked(phrase, pool, bundleDomainsExtensions)
          }}
        />
      </PushOrg>

      <SubmitFieldBottomTexts
        onNextStepClick={onNextStepClick}
        nextStep={nextStep}
        hideText={hideText}
      />
    </>
  )
}
